'use strict';

var React = require('react');

var SvgOrderStatusMinor = function SvgOrderStatusMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m8.579 5.615-.867 1.409a1 1 0 0 1-.852.476h-1.86a.75.75 0 1 1 0-1.5h1.58l1.428-2.32c.486-.79 1.693-.55 1.84.367l.59 3.694.864-1.296a1 1 0 0 1 .832-.445h2.866a.75.75 0 0 1 0 1.5h-2.599l-1.423 2.135c-.505.757-1.676.501-1.82-.397l-.58-3.623Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.156 10 .132-.89a.75.75 0 1 0-1.484-.22l-.21 1.417a8.75 8.75 0 0 0-.094 1.282v1.661a3.25 3.25 0 0 0 3.25 3.25h6.5a3.25 3.25 0 0 0 3.25-3.25v-1.66c0-.43-.032-.858-.095-1.283l-.21-1.417a.75.75 0 0 0-1.483.22l.132.89h-2.484a1.25 1.25 0 0 0-1.185.855l-.159.474a.25.25 0 0 1-.237.171h-1.558a.25.25 0 0 1-.237-.17l-.159-.475a1.25 1.25 0 0 0-1.185-.855h-2.484Zm-.155 1.5-.001.09v1.66c0 .967.784 1.75 1.75 1.75h6.5a1.75 1.75 0 0 0 1.75-1.75v-1.75h-2.46l-.1.303a1.75 1.75 0 0 1-1.66 1.197h-1.56a1.75 1.75 0 0 1-1.66-1.197l-.1-.303h-2.46Z"
  }));
};
SvgOrderStatusMinor.displayName = "OrderStatusMinor";

exports.SvgOrderStatusMinor = SvgOrderStatusMinor;
